import { render, staticRenderFns } from "./notification-panel.vue?vue&type=template&id=0d893a9f"
import script from "./notification-panel.vue?vue&type=script&lang=js"
export * from "./notification-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports